import { TranscparencyMainData } from "apiTypes";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import useFormatNumbers from "../../customHooks/useFormatNumbers";
import useRTL from "../../customHooks/useRTL";
import CustomContentLoader from "../ReuseableCompos/CustomContentLoader";
import NoData from "../ReuseableCompos/NoData";

type SkeletonProps = {
  height: string;
  width: string;
  x: string;
  isSingle: boolean;
};
const TransparencySkeleton = ({
  height,
  isSingle,
  width,
  x,
}: SkeletonProps) => {
  return (
    <div className="d-flex py-2 flex-md-row flex-column">
      <div className={`col-md-6 col-sm-12 my-2 px-md-2 px-0`}>
        <CustomContentLoader viewBox={`0 0 400 ${height}`}>
          <rect x={x} y="0" rx="12" ry="12" width={width} height={height} />
        </CustomContentLoader>
      </div>
      {!isSingle && (
        <div className={`col-md-6 col-sm-12 my-2 px-md-2 px-0`}>
          <CustomContentLoader viewBox={`0 0 400 ${height}`}>
            <rect x={x} y="0" rx="12" ry="12" width={width} height={height} />
          </CustomContentLoader>
        </div>
      )}
    </div>
  );
};

type Props = {
  data: TranscparencyMainData;
  error: any;
  rec: boolean;
  spent: boolean;
  isLoading: boolean;
};
const TransparencyDonationCards = ({
  data,
  error,
  rec,
  spent,
  isLoading,
}: Props) => {
  const { t } = useTranslation("common");
  const { formatNumbers } = useFormatNumbers();
  const isRTL = useRTL();
  const both = rec && spent;
  const isMobile = useMobile("md");

  return (
    <div>
      {(!data && !error) || isLoading ? (
        <TransparencySkeleton
          height={isMobile ? "138" : "100"}
          width={isMobile ? "350" : "400"}
          x={isMobile ? "25" : "0"}
          isSingle={(rec && !spent) || (!rec && spent)}
        />
      ) : (
        <>
          {error ? (
            <NoData error={JSON.stringify(error)} />
          ) : (
            <div className="d-flex flex-md-row flex-column">
              {rec && (
                <div
                  className={`col-md-6 col-sm-12 mb-3 ${
                    both ? `p${isRTL ? "s" : "e"}-md-2 px-0` : "px-3 mt-3"
                  }`}
                >
                  <div className="bg-secondary h-100 rounded-3 p-4 text-center">
                    <h3 className="fs-sm fw-medium text-body mb-2">
                      <i className="fe-arrow-right font-size-xl text-success"></i>{" "}
                      {t(`total_of_donations_received`)}
                    </h3>
                    <p className="h2 mb-2" dir="auto">
                      {formatNumbers(
                        data?.received?.total["usd"],
                        "usd",
                        false,
                        true
                      )}
                    </p>
                    <p className="fs-ms text-muted mb-0">
                      {/* {t(`or_equivalent`)}{" "} */}
                      <span dir="auto">{t("usd")}</span>
                    </p>
                  </div>
                </div>
              )}
              {spent && (
                <div
                  className={`col-md-6 col-sm-12 mb-3 ${
                    both ? `p${isRTL ? "e" : "s"}-md-2 px-0 ` : "px-3 mt-3"
                  }`}
                >
                  <div className="bg-secondary h-100 rounded-3 p-4 text-center">
                    <h3 className="fs-sm fw-medium text-body mb-2">
                      <i
                        className={`ai-arrow-${
                          isRTL ? "right" : "left"
                        } font-size-xl text-danger`}
                      ></i>{" "}
                      {t(`total_of_donations_spent`)}
                    </h3>

                    <p className="h2 mb-2" dir="auto">
                      {formatNumbers(
                        data?.spent?.total["usd"],
                        "usd",
                        false,
                        true
                      )}
                    </p>
                    <p className="fs-ms text-muted mb-0">
                      <span dir="auto">{t("usd")}</span>
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TransparencyDonationCards;
